









































































import { Component, Vue, Watch } from 'vue-property-decorator';
import axios from 'axios';
import { api } from '@/api';
import { Debounce } from 'lodash-decorators';
import ActivityDetails from '@/components/dashboard/admin/activity/ActivityDetails.vue';

@Component({
  components: {
    ActivityDetails,
  },
})
export default class ActivityLogTable extends Vue {
  public activities = [];

  public activitiesLoading: boolean = false;

  public pagination: any = {
    page: 1,
    itemsPerPage: 10,
  };

  public totalItems: number = 0;

  /* public filters: any = {
            description: null,
            causer: null,
            causer_email: null,
            subject: null,
        } */

  get headersLocalized(): any[] {
    return [
      {
        text: this.$t('table_headers.activities.description'),
        value: 'description',
      },
      {
        text: this.$t('table_headers.activities.causer'),
        value: 'causer',
      },
      {
        text: this.$t('table_headers.activities.subject'),
        value: 'subject',
      },
      {
        text: this.$t('table_headers.shared.created_at'),
        value: 'created_at',
      },
      {
        text: this.$t('table_headers.shared.actions'),
        value: 'actions',
        align: 'end',
      },
    ];
  }

  public activityDialog: boolean = false;

  public selectedActivity: any = null;

  public setActivities(data: any) {
    this.activities = data.data;
    this.totalItems = data.meta.total;
  }

  public loadActivities() {
    this.activitiesLoading = true;

    let params: any = {
      /* ...this.filters, */
      page: this.pagination.page,
      per_page: this.pagination.itemsPerPage,
    };

    axios
      .get(api.path('v1.admin.activities'), { params: params })
      .then((res) => this.setActivities(res.data))
      .finally(() => (this.activitiesLoading = false));
  }

  /* @Watch('filters', { deep: true })
        @Debounce(500)
        handleFilters() {
            this.loadTransactions();
        } */

  @Watch('pagination', { deep: true })
  @Debounce(500)
  onFilterValueChange(value: any) {
    this.loadActivities();
  }

  @Watch('pagination.page')
  onPageChange() {
    if (this.$vuetify.breakpoint.mobile) {
      this.$vuetify.goTo(0);
    }
  }

  public showDetails(item: any) {
    this.selectedActivity = item;

    this.activityDialog = true;
  }

  public mounted() {
    this.loadActivities();
  }
}
